export default "__VITE_ASSET__BugS1WsG__"